(function () {
  'use strict';

  angular
    .module('minRestBreachPriorToRktDeparture')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('minRestBreachPriorToRktDeparture', {
        url: '/min-rest-breach-prior-to-rkt-departure',
        views: {
          'minRestBreachPriorToRktDepartureView': {
            templateUrl: 'min-rest-breach-prior-to-rkt-departure/views/min-rest-breach-prior-to-rkt-departure.tpl.html',
            controller: 'minRestBreachPriorToRktDepartureCtrl',
            controllerAs: 'minRestBreachPriorToRktDeparture'
          }
        }
      });
  }
}());
